import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import Select from 'react-select';
import { css } from "styled-components/macro"; 
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg/svg-decorator-blob-5.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg/svg-decorator-blob-7.svg";
import Noimg from "../images/no_img.jpg";
import { getProduct, orderStatus } from "../api/ProductApi.js";
import { currentRegister} from "utility/Constant.js";
import { Link, useNavigate } from "react-router-dom";
import ProductCommon from "../components/ProductLike&Wish";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import no_data from "images/no_data.png";
import SkeletonLoader from "components/SkeletonLoader";
import { useLocation } from "react-router-dom";
import { getBranchId } from "utility/HeaderConfig";

const Container = tw.div`relative font-display overflow-hidden`;
const TabContent = tw(motion.div)`block `;
const CardContainer = tw.div`mt-4 w-full relative`;
const Card = tw(
  motion.div
)`bg-white block mx-auto  sm:mx-0 no-underline hover:shadow-2xl rounded-lg duration-500 cursor-pointer `;
const CardImageContainer = styled.div`
  ${(props) =>
    css`
      background-image: url("${props.imageSrc}");
    `}
  ${tw`bg-center bg-cover relative h-80 border border-gray-400 border-solid rounded-t-lg `}
`;
const CardText = tw.div`p-4 pb-1 text-gray-900 bg-gray-200 border border-gray-400 border-solid rounded-b-lg`;
const CardTitle = tw.h5`text-sm group-hover:text-yellow-600 no-underline  text-gray-600 lowercase`;
const CardContent = tw.p`mt-1 mb-2 text-sm font-medium text-custom-100  uppercase`;
const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-64 w-64 opacity-15 transform translate-x-2/3 -translate-y-12 text-pink-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-80 w-80 opacity-15 transform -translate-x-2/3 text-custom-100`}
`;
const OccasionCategoriesComponent = ({configImages}) => {


  const history = useNavigate();
  const location = useLocation();
  // const occationCateData = location.state.occasionCate; 

  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [size, setSize] = useState(12);
  const [banner, setBanner] = useState([]);
  // const [occasionDetails, setOccasionDetails] = useState({})
  const [orderStatusSale, setOrderStatusSale] = useState("");
  const [orderStatusTransfer, setOrderStatusTransfer] = useState("");
  const [orderStatusSold, setOrderStatusSold] = useState("");
  const [selectedOption,setSelectedOption] = useState({id: 3,label:'MAHAVEL',value:'/108 MAHAVEL'})
  
  
  const pageList = [

    {id: 1,label:'NEW ARRIVALS',value:'/NewArrivals'},
    {id: 2,label:'MOST LIKED PRODUCT',value: '/MostLiked'},
    // {id: 3,label:'OCCASION CATEGORIES',value:'/OccasionCategoriesComponent'},
    {id: 4,label:'TREND ON SHOPS',value:'/TrendOnShopComponent'},
    {id: 5,label:'SHOP OUR EXCLUSIVE',value: '/ShopOurExclusiveComponent'},
    {id: 6,label:'BEST SELLING',value:'/BestSellingComponent'},
    
  ];
  

  useEffect(() => {
    Promise.all([
      getOrderStatusSale(),
      getOrderStatusTransfer(),
      getOrderStatusSold(),
      banners()      
    ])
    // eslint-disable-next-line
    .then((result) => {
      // if(location?.state?.occasionCate){
        // setOccasionDetails({
        //   name :occationCateData.name ? occationCateData.name:"", 
        //   displayName : occationCateData.displayName ? occationCateData.displayName : ""
        // })
        getOccation(result[0], result[1], result[2]);
      // }
    })
    .catch((err) => console.error(err));
    //eslint-disable-next-line
  }, []);


  const getOrderStatusSale = () => {
    return orderStatus({ orderStatusName: "sale" })
      .then((data) => {
        setOrderStatusSale(data.response[0].id);
        return data.response[0].id;
      })
      .catch((err) => console.error(err));
  };

  const getOrderStatusTransfer = () => {
    return orderStatus({ orderStatusName: "Transferred" })
      .then((data) => {
        setOrderStatusTransfer(data.response[0].id);
        return data.response[0].id;
      })
      .catch((err) => console.error(err));
  };

  const getOrderStatusSold = () => {
    return orderStatus({ orderStatusName: "Sold" })
      .then((data) => {
        setOrderStatusSold(data.response[0].id);
        return data.response[0].id;
      })
      .catch((err) => console.error(err));
  };

  const getOccation = (
    orderSaleStatus,
    orderTransferStatus,
    orderSoldStatus,
  ) => {
    setLoading(true);
    setSize(2000);
      getProduct(size,{
        branch: getBranchId(),
        productLabel: '108 MAHAVEL', 
        removeNTP: "NTP-",
        removeHP: "HP-",
        beforeCreatedAt: currentRegister(),
        sortType: true,
        demoStatus: "Demo_Completed,Demo_Cancelled,Available_For_Demo",
        statusId: `${orderSaleStatus},${orderTransferStatus},${orderSoldStatus}`
      })
        .then((data) => {
          setCategoryList(data.response.content);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
        });
  }

  const handleMenuItemClick = (menuItem) => {
    setSelectedOption(menuItem)
    history(`/${menuItem.value}`)  
    };


  function banners() {
    configImages &&
      configImages.E_COMMERCE_BANNERS.forEach((data) => {
        if (data.key === "newArrivals") {
          setBanner(data.value);
        }
      });
  };

 return (
  <Container>
    {banner && banner.length > 0 ? (
      <img src={banner} alt="New Arrivals Products" className="w-100" style={{ maxHeight: "400px", objectFit: "cover" }} />
    ) : (
      <Skeleton tw="w-full" style={{ height: "200px" }} />
    )}
    
    {/* Breadcrumb Navigation */}
    <div className="ptSans px-sm-5 px-3" tw="text-sm pt-3 text-gray-600">
      <Link to="/" tw="no-underline text-gray-700 hover:text-custom-100 transition-colors duration-200">
        Home
      </Link>
      /
      <span tw="ml-2 text-custom-100 font-semibold capitalize tracking-wide">
        108 MAHAVEL
      </span>
    </div>

    {/* 108 MAHAVEL Center Display */}
    <div className="d-flex justify-content-center my-4">
      <div className="text-center">
        <div className="position-relative inline-block">
          <h1 className="display-5 fw-bold text-gold mb-0" style={{ 
            color: '#d4af37',
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
            letterSpacing: '3px'
          }}>
            108 Divine Vel Series
          </h1>
          <div className="position-absolute w-100" style={{ bottom: '-10px' }}>
            <div className="mx-auto" style={{ 
              width: '150px', 
              height: '3px', 
              background: 'linear-gradient(90deg, transparent, #d4af37, transparent)',
              borderRadius: '2px'
            }}></div>
          </div>
        </div>
        <p className="text-muted mt-3 mb-0" style={{ fontSize: '0.9rem' }}>
          Exquisite Collection of Divine Jewellery
        </p>
      </div>
    </div>

    {/* Current Gold & Silver Prices */}
    {/* <div className="container my-4">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="d-flex justify-content-center flex-wrap gap-4 p-3" style={{ 
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
          }}>
            <div className="text-center px-4 py-2">
              <div className="d-flex align-items-center justify-content-center">
                <div className="me-2" style={{ 
                  width: '12px', 
                  height: '12px', 
                  backgroundColor: '#d4af37', 
                  borderRadius: '50%',
                  boxShadow: '0 0 8px rgba(212, 175, 55, 0.5)'
                }}></div>
                <span className="fw-bold text-dark">GOLD</span>
              </div>
              <div className="mt-1">
                <span className="h5 fw-bold" style={{ color: '#d4af37' }}>₹12,369/gm</span>
                <small className="text-muted d-block">(22K)</small>
              </div>
            </div>
            
            <div className="border-start border-2 border-gray-300"></div>
            
            <div className="text-center px-4 py-2">
              <div className="d-flex align-items-center justify-content-center">
                <div className="me-2" style={{ 
                  width: '12px', 
                  height: '12px', 
                  backgroundColor: '#c0c0c0', 
                  borderRadius: '50%',
                  boxShadow: '0 0 8px rgba(192, 192, 192, 0.5)'
                }}></div>
                <span className="fw-bold text-dark">SILVER</span>
              </div>
              <div className="mt-1">
                <span className="h5 fw-bold" style={{ color: '#6c757d' }}>₹209/gm</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> */}

    <div className="py-0 pb-2 mb-5 position-relative">
      <div className="container container-influid-md">
        {/* Product Grid */}
        <div className="row">
          {categoryList.length === 0 && !loading ? (
            <div className="col-12 text-center py-5">
              <img src={no_data} alt="no-data" className="col-md-4 m-auto opacity-75" />
              <p className="text-muted mt-3">No products available at the moment</p>
            </div>
          ) : (
            categoryList.map((categoryItem, index) => (
              <TabContent
                key={index}
                transition={{ duration: 0.4 }}
                className="col-md-6 col-lg-4 col-xl-3 mb-4"
              >
                <CardContainer>
                  <ProductCommon categoryItem={categoryItem} />
                  <Card
                    className="group card-hover"
                    initial="rest"
                    whileHover="hover"
                    animate="rest"
                    onClick={() =>
                      history(`/ProductDetails/${categoryItem.id}`, {state:{categoryItem}})
                    }
                    style={{
                      transition: 'all 0.3s ease',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                    }}
                  >
                    <div className="overflow-hidden position-relative">
                      <CardImageContainer
                        imageSrc={
                          categoryItem.images === "@#@"
                            ? Noimg
                            : categoryItem.images.split("@#@")[0]
                        }
                        tw="transform transition-transform duration-500 group-hover:scale-110"
                        style={{ height: '250px', objectFit: 'cover' }}
                      ></CardImageContainer>
                      
                      {/* Stock Badge */}
                      {categoryItem.stockStatus === "Sale" ? (
                        <div
                          className="position-absolute top-0 start-0 m-3"
                          style={{ zIndex: 10 }}
                        >
                          <span className="badge bg-success px-3 py-2" style={{ 
                            fontSize: '0.75rem',
                            borderRadius: '20px'
                          }}>
                            <i className="bi bi-check-circle me-1"></i> Available
                          </span>
                        </div>
                      ): (
                        <div
                          className="position-absolute top-0 start-0 m-3"
                          style={{ zIndex: 10 }}
                        >
                          <span className="badge bg-Warning px-3 py-2" style={{ 
                            fontSize: '0.75rem',
                            borderRadius: '20px'
                          }}>
                            <i className="bi bi-check-circle me-1"></i> Order Now
                          </span>
                        </div>
                      )
                      }
                      
                      {/* Quick View Overlay */}
                      <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                        style={{
                          background: 'rgba(0,0,0,0.4)',
                          opacity: 0,
                          transition: 'opacity 0.3s ease',
                          zIndex: 5
                        }}
                        tw="group-hover:opacity-100"
                      >
                        <button className="btn btn-light btn-sm rounded-pill px-4 py-2">
                          <i className="bi bi-eye me-2"></i> Quick View
                        </button>
                      </div>
                    </div>
                    
                    <CardText className="p-3">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div className="col-md-8 pe-2">
                          <CardTitle className="capitalize fw-bold mb-1" style={{ 
                            color: '#333',
                            fontSize: '1rem'
                          }}>
                            {categoryItem.metalType}
                          </CardTitle>
                          <CardContent
                            className="capitalize text-muted"
                            style={{
                              fontSize: '0.85rem',
                              lineHeight: '1.3'
                            }}
                            title={categoryItem.title}
                          >
                            {categoryItem.category}
                          </CardContent>
                        </div>
                        <div className="col-md-4 text-end">
                          <div className="d-flex flex-column align-items-end">
                            <b className="text-lg fw-bold text-dark" style={{ 
                              fontSize: '1.1rem',
                              color: '#d4af37'
                            }}>
                              <span className="rupee-symbol">₹</span>
                              {Math.trunc(categoryItem.total).toLocaleString()}
                            </b>
                            {categoryItem.goldPurity !== "-" && (
                              <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                                {categoryItem.goldPurity}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                      
                      {/* View Details Button */}
                      <div className="mt-3 pt-2 border-top border-light">
                        <button className="btn btn-outline-custom w-100 btn-sm rounded-pill py-2"
                          onClick={(e) => {
                            e.stopPropagation();
                            history(`/ProductDetails/${categoryItem.id}`, {state:{categoryItem}});
                          }}
                          style={{
                            borderColor: '#d4af37',
                            color: '#d4af37',
                            transition: 'all 0.3s ease'
                          }}
                          tw="hover:bg-custom-100 hover:text-white"
                        >
                          Customize <i className="bi bi-arrow-right ms-1"></i>
                        </button>
                      </div>
                    </CardText>
                  </Card>
                </CardContainer>
              </TabContent>
            ))
          )}
          
          {loading && <SkeletonLoader />}
          
          {/* View More Button */}
          <div className="d-flex justify-content-center pt-5 mt-3">
            <button
              className="btn btn-outline-custom px-5 py-3 rounded-pill fw-medium"
              onClick={() => {
                getOccation(
                  orderStatusSale,
                  orderStatusTransfer,
                  orderStatusSold,
                );
              }}
              style={{
                borderColor: '#d4af37',
                color: '#d4af37',
                transition: 'all 0.3s ease',
                minWidth: '180px'
              }}
              disabled={loading}
              tw="hover:bg-custom-100 hover:text-white hover:border-custom-100"
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  Loading...
                </>
              ) : (
                <>
                  View More <i className="bi bi-chevron-down ms-2"></i>
                </>
              )}
            </button>
          </div>
          
          <DecoratorBlob1 />
          <DecoratorBlob2 />
        </div>
      </div>
    </div>
  </Container>
);
};


export default OccasionCategoriesComponent;
